import useTransform from '@/shared/GameComponents/GameObjects/SimpleImage/useTransfrom.hook';
import { StyledSoundPlayingIcon } from './SoundPlayingIcon.styled';

export default function SoundPlayingIcon() {
  const { responsiveTransform, originalSize } = useTransform({
    transform: {
      x: 95,
      y: 92,
      width: 4,
      height: 4,
      pivot: { x: 50, y: 50 },
    },
    pixelSize: {
      width: 4,
      height: 4,
    },
  });

  return (
    <>
      {responsiveTransform && (
        <StyledSoundPlayingIcon
          responsiveTransform={responsiveTransform}
          originalSize={originalSize}
        >
          <div className="audio-playing"></div>
        </StyledSoundPlayingIcon>
      )}
    </>
  );
}
